import {
  DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME,
  DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME,
  SET_PAYMENT_MESSAGE_FOR_REG_HOME,
  SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME,
  SET_TOURNAMENT_LOADING_FOR_REG_HOME,
  DISPLAY_BIRTH_DATE_MODAL,
  DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL,
  SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT
} from './constants';

export const initialState = {
  activeTournaments: [],
  activeTournamentCount: undefined,
  paymentMessage: '',
  maintenanceMessage: null,
  searchValue: '',
  loadingTournaments: true,
  showBirthDateModal: false,
  showRequiredProfileFieldsModal: false,
  captainAge: 0
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
  case SET_PAYMENT_MESSAGE_FOR_REG_HOME:
    return {
      ...state,
      paymentMessage: payload || initialState.paymentMessage
    };
  case SET_SEARCH_TOURNAMENT_VALUE_FOR_REG_HOME:
    return {
      ...state,
      searchValue: payload.searchValue || initialState.searchValue
    };
  case SET_TOURNAMENT_LOADING_FOR_REG_HOME:
    return {
      ...state,
      loadingTournaments: true
    };
  case DISPLAY_ACTIVE_TOURNAMENTS_FOR_REG_HOME:
    { 
      let activeTournamentCount = state.activeTournamentCount;

      if (payload && payload.activeTournaments && !activeTournamentCount) activeTournamentCount = payload.activeTournaments.length;
        if (!payload) payload = { activeTournaments: [], loadingTournaments: false };
      return {
        ...state,
        ...payload,
        activeTournamentCount: activeTournamentCount
      };
    }
  case DISPLAY_MAINTENANCE_MESSAGE_FOR_REG_HOME:
    { 
      return {
        ...state,
        ...payload 
      };
  }
  case DISPLAY_BIRTH_DATE_MODAL:
    return {
      ...state,
      showBirthDateModal: payload || initialState.showBirthDateModal
    };
  case DISPLAY_REQUIRED_PROFILE_FIELDS_MODAL:
    return {
      ...state,
      showRequiredProfileFieldsModal: payload || initialState.showRequiredProfileFieldsModal
    }; 
  case SET_CAPTAIN_AGE_FOR_SELECTED_TOURNAMENT:
    return {
      ...state,
      captainAge: payload || initialState.captainAge
    };
  default:
    return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/registration/home/reducer.js